var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,22c-1.4,0-2.7-.3-3.9-.8s-2.3-1.2-3.2-2.2-1.6-2-2.2-3.2-.8-2.5-.8-3.9.3-2.7.8-3.9,1.2-2.3,2.2-3.2,2-1.6,3.2-2.2,2.5-.8,3.9-.8.5,0,.7.3c.2.2.3.4.3.7s0,.5-.3.7c-.2.2-.4.3-.7.3-2.2,0-4.1.8-5.7,2.3-1.6,1.6-2.3,3.4-2.3,5.7s.8,4.1,2.3,5.7c1.6,1.6,3.4,2.3,5.7,2.3s4.1-.8,5.7-2.3c1.6-1.6,2.3-3.4,2.3-5.7s0-.5.3-.7c.2-.2.4-.3.7-.3s.5,0,.7.3c.2.2.3.4.3.7,0,1.4-.3,2.7-.8,3.9s-1.2,2.3-2.2,3.2-2,1.6-3.2,2.2-2.5.8-3.9.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.870c2c7b1d40a1376218f637849a6655.svg";
export { ForwardRef as ReactComponent };